import React from 'react';
import { motion } from 'framer-motion';
import slider1 from '../../../assets/images/occupational_theropy/slider_1.jpg';
import slider2 from '../../../assets/images/occupational_theropy/slider_2.jpg';
import slider3 from '../../../assets/images/occupational_theropy/slider_3.jpg';
import GradientButton from '../../../components/atoms/GradientButton';
import GradientOutlineButton from '../../../components/atoms/GradientOutlineButton';
import CrossFadeImageSlider from '../../../components/molecules/CrossFadeImageSlider';
import { Link } from 'react-router-dom';

const images = [
  {
    src: slider1,
    alt: 'Occupational therapy handwriting practice in Wasilla, Alaska',
  },
  {
    src: slider2,
    alt: 'Wasilla therapy clinic sensory integration tools',
  },
  {
    src: slider3,
    alt: 'Wasilla occupational therapy fine motor activity kit',
  },
];

function PediatricOccupationalTherapy() {
  return (
    <div className="w-full flex flex-col justify-between gap-4 sm:gap-10 max-w-[1200px] mx-auto px-4 md:px-10 py-10 md:py-20 relative z-10">
      <div>
        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.9, ease: 'easeOut' }}
          viewport={{ once: true, amount: 0.5 }}
        >
          <h4 className="text-[32px] sm:text-[42px] md:text-[48px] text-[#7B54A2] font-bold leading-[40px] lg:leading-[50px] md:mr-4">
            Pediatric occupational therapy is a specialized field dedicated to
            helping children develop the skills they need to succeed in daily
            activities and reach their full potential.
          </h4>
        </motion.div>
      </div>
      <div className="flex flex-col md:flex-row justify-between w-full gap-4 sm:gap-10 xl:gap-32">
        <div className="flex-1 flex flex-col items-start gap-4 sm:gap-6 lg:gap-10 font-custom text-lg md:text-xl 2xl:text-2xl text-secondary">
          <p>
            Through a holistic and play-based approach, Guidepost occupational
            therapists work with children to address challenges and enhance
            their physical, cognitive, sensory, and social-emotional abilities.
          </p>
          <p>
            Here at Guidepost Pediatrics, our occupational therapists focus on
            promoting a child's independence and participation in activities
            that are essential to their everyday life. Occupational therapists
            work closely with children, their families, and caregivers to assess
            and address difficulties related to self-care, play, school tasks,
            and social interactions. By using purposeful and engaging
            activities, therapists facilitate skill development and empower
            children to navigate their world with confidence.
          </p>
          <p>
            <Link
              to="/contact"
              className="text-[#7F4B9D] underline font-semibold hover:text-[#693c84] transition-colors"
            >
              Contact us today
            </Link>
            &nbsp; to learn more about the world of pediatric occupational
            therapy, explore its core principles, benefits, and the conditions
            it can effectively address. core
          </p>
          <div className="w-full flex flex-col md:flex-row gap-5 md:gap-14">
            <GradientOutlineButton
              navigateTo={'/our-team'}
              text="Meet Our Therapists"
              width="lg:w-[240px] w-full"
            />
            <GradientButton
              navigateTo={'/contact'}
              text="Schedule an Evaluation"
              width="lg:w-[240px] w-full"
            />
          </div>
        </div>
        <div className="flex-1 flex justify-end overflow-hidden">
          <CrossFadeImageSlider
            width="w-full md:w-[400px] 2xl:w-[500px]"
            height="h-[300px] sm:h-[400px] md:h-[500px]"
            images={images}
          />
        </div>
      </div>
    </div>
  );
}

export default PediatricOccupationalTherapy;
